// extracted by mini-css-extract-plugin
export default {"screen-wrapper":"screen_screen-wrapper__Hvmqb"};